import React, { FunctionComponent, useMemo } from "react";
import TraitSalesContext, {
  TraitSalesContextValue,
} from "contexts/TraitSalesContext";
import useFetchTraitSales from "hooks/useFetchTraitSales";
import { Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import useConnectedAccount from "hooks/useConnectedAccount";

type TraitSalesProviderProps = {};

const TraitSalesProvider: FunctionComponent<TraitSalesProviderProps> = ({
  children,
}) => {
  const [address] = useConnectedAccount();
  const [traitSales, fetch, isLoading] = useFetchTraitSales(address);

  const traitSalesByTokenId = useMemo(
    () =>
      traitSales?.reduce(
        (prev, sale) => ({
          ...prev,
          [sale.tokenId]: sale,
        }),
        {}
      ),
    [traitSales]
  );

  const contextValue = useMemo<TraitSalesContextValue>(
    () => ({
      traitSales: traitSales || [],
      traitSalesByTokenId: traitSalesByTokenId || {},
      fetchTraitSales: () => {
        fetch(address);
      },
      isLoading,
    }),
    [traitSales, traitSalesByTokenId, fetch, address, isLoading]
  );

  return (
    <TraitSalesContext.Provider value={contextValue}>
      {!traitSales ? (
        <Center h="100vh">
          <BoldSpinner size="xl" />
        </Center>
      ) : (
        children
      )}
    </TraitSalesContext.Provider>
  );
};

export default TraitSalesProvider;
